export default {
  default: {
    client:'socket.io'
  },
  local: {
  },
  daily: {
  },
  prod: {
  }
}
